import React, { useEffect, useState, useRef } from "react";
import Swiper from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function CardItem({
  item,
  setbuyListActive,
  setOpenDescriptionCard,
  setDescriptionTitle,
}) {
  const [cardImageArray, setCardImageArray] = useState([]);
  const [isSwiperReady, setIsSwiperReady] = useState(false);
  const [imageLoading, setImageLoading] = useState(true);
  const [imageError, setImageError] = useState(false);

  const swiperContainerRef = useRef(null);
  const swiperInstanceRef = useRef(null);

  // Эффект для обновления изображений
  useEffect(() => {
    setCardImageArray(item.url);
    setImageLoading(true);
    setImageError(false);

    if (swiperInstanceRef.current) {
      swiperInstanceRef.current.destroy(true, true);
      swiperInstanceRef.current = null;
    }

    setIsSwiperReady(false);
  }, [item.url]);

  // Эффект для инициализации Swiper
  useEffect(() => {
    if (
      cardImageArray.length > 0 &&
      swiperContainerRef.current &&
      !isSwiperReady
    ) {
      const hasMultipleImages = cardImageArray.length > 1;

      swiperInstanceRef.current = new Swiper(swiperContainerRef.current, {
        speed: 400,
        slidesPerView: 1,
        loop: hasMultipleImages,
        spaceBetween: 10,
        navigation: hasMultipleImages
          ? {
              nextEl: `.swiper-button-next-${item.id}`,
              prevEl: `.swiper-button-prev-${item.id}`,
            }
          : false,
        pagination: hasMultipleImages
          ? {
              el: `.swiper-pagination-${item.id}`,
              clickable: true,
            }
          : false,
      });

      setIsSwiperReady(true);
    }
  }, [cardImageArray, isSwiperReady, item.id]);

  // Cleanup
  useEffect(() => {
    return () => {
      if (swiperInstanceRef.current) {
        swiperInstanceRef.current.destroy(true, true);
      }
    };
  }, []);

  const openDescription = () => {
    setDescriptionTitle(item.description);
    setOpenDescriptionCard(true);
  };

  const buyCard = () => {
    setbuyListActive(true);
  };

  const handleImageLoad = () => setImageLoading(false);
  const handleImageError = () => {
    setImageLoading(false);
    setImageError(true);
  };

  const hasMultipleImages = cardImageArray.length > 1;

  return (
    <article id={item.id} className="productGrid-cardItem">
      <div className="swiper" ref={swiperContainerRef}>
        <div className="swiper-wrapper">
          {cardImageArray.map((card, index) => (
            <div key={card.id || index} className="swiper-slide">
              <div className="image-container">
                <img
                  className="productGrid-cardItem-img"
                  src={imageError ? "/images/placeholder.jpg" : card.url}
                  alt={`${item.title} - изображение ${index + 1}`}
                  onLoad={handleImageLoad}
                  onError={handleImageError}
                  style={{ display: imageLoading ? "none" : "block" }}
                />
                {imageLoading && (
                  <div className="loader-container">
                    <span className="loader"></span>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {hasMultipleImages && cardImageArray.length > 0 && (
          <>
            <div
              className={`swiper-pagination swiper-pagination-${item.id}`}
            ></div>
            <div
              className={`swiper-button-prev swiper-button-prev-${item.id}`}
            ></div>
            <div
              className={`swiper-button-next swiper-button-next-${item.id}`}
            ></div>
          </>
        )}
      </div>

      <button className="descriptionProduct" onClick={openDescription}>
        Описание
      </button>

      <span className="numberOfPieces">{item.numberOfPieces}</span>

      <div className="productGrid-cardItem-card-description">
        <h4 className="productGrid-cardItem-card-title">{item.title}</h4>
        <p className="productGrid-cardItem-card-price">{item.price}</p>
      </div>

      <button className="elementBuy" onClick={buyCard}>
        Купить
      </button>
    </article>
  );
}

export default CardItem;
